jQuery('html').on('click', function() {
    jQuery('.popover').addClass('hidden');
});

jQuery('[data-toggle="popover"]').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    jQuery(jQuery(this).attr('data-element')).toggleClass('hidden');
});